'use client';
import React from 'react';
import { Box, Typography } from '@mui/material';

import { AutoAwesome } from '@mui/icons-material';
import CTASection from '../components/landing/CTASection';
import PlansSection from '../components/landing/PlansSection';
import ComparisonSection from '../components/landing/ComparisonSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import HeroSection from '../components/landing/HeroSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/landing/Footer';
import ProblemSection from '../components/landing/ProblemSection';
import SocialProofSection from '../components/landing/SocialProofSection';
import { PwaInstallButton } from '../components/PwaInstallPrompt';
import { useFeatureFlags } from '../contexts/FeatureFlagContext';

export default function LandingPage() {
  const { isEnabled, isLoading: flagsLoading } = useFeatureFlags();
  const pwaInstallEnabled = !flagsLoading && isEnabled('pwa_install') === true;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />

      {/* AI-proof platform banner */}
      <Box sx={{ bgcolor: '#E8F5F3', py: 1, textAlign: 'center', borderBottom: '1px solid #C8DDD8' }}>
        <Typography variant="body2" sx={{ color: '#2D6E6A', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <AutoAwesome sx={{ fontSize: 16 }} />
          Built by a solo founder using AI — <Typography component="a" href="/resources" variant="body2" sx={{ color: '#2D6E6A', fontWeight: 700, textDecoration: 'underline' }}>Click here for builder experience</Typography>
        </Typography>
      </Box>

      <Box component="main" sx={{ flex: 1 }}>
        <Box id="hero">
          <HeroSection />
        </Box>

        {/* PWA install — gated behind 'pwa_install' flag */}
        {pwaInstallEnabled && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <PwaInstallButton size="large" />
          </Box>
        )}

        <Box id="problem">
          <ProblemSection />
        </Box>

        <Box id="features">
          <FeaturesSection />
        </Box>

        <Box id="how-it-works">
          <HowItWorksSection />
        </Box>

        <Box id="social-proof">
          <SocialProofSection />
        </Box>

        <Box id="comparison">
          <ComparisonSection />
        </Box>

        <Box id="plans">
          <PlansSection />
        </Box>
        <Box id="cta">
          <CTASection />
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}
